module.exports = "<div id=\"woMain\" >\r\n  <div id=\"xsmspacer\"></div>\r\n  <pre>{{admission}} </pre>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/workOrderAdmissions/WorkOrderAdmissions.component.html
// module id = ./src/app/workOrderAdmissions/WorkOrderAdmissions.component.html
// module chunks = app